import { Grid as MuiGrid, Typography as MuiTypography } from "@mui/material";
import InfoCard from "./InfoCard";
import BigMetric from "./BigMetric";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const showNumPeopleOnStudyFeature = false;

const WebsiteActivityCard = ({
  interestedCount,
  interestCountFromCt,
  isPublishable,
}) => {
  const { t } = useTranslation();
  return (
    <InfoCard
      title={t("studyInsights.websiteActivity")}
      helpText={
        "The Website Activity Card provides an overview of recruitment activity on your study's website. It displays the total number of people who expressed interest over all time and the number of people who showed interest through the Clinical Trials Directory."
      }
    >
      <MuiGrid
        container
        spacing={4}
        sx={{ justifyContent: "center", alignItems: "flex-start" }}
      >
        {isPublishable && (
          <>
            <MuiGrid size={{ xs: 12, md: 6 }} sx={{ textAlign: "center" }}>
              <BigMetric
                value={interestCountFromCt}
                label={
                  "Total number of people who\nexpressed interest over all time through the Clinical Trials Directory"
                }
              />
            </MuiGrid>
            {showNumPeopleOnStudyFeature && (
              <MuiGrid size={{ xs: 12, md: 6 }} sx={{ textAlign: "center" }}>
                <BigMetric
                  value={interestCountFromCt}
                  label={[
                    "Number of people on study who",
                    "showed interest through the",
                    "Clinical Trials Directory",
                  ].join("\n")}
                />
              </MuiGrid>
            )}
          </>
        )}
        {!isPublishable && (
          <MuiGrid size={{ xs: 12 }} sx={{ textAlign: "center" }}>
            <MuiTypography variant="body2" color="textSecondary">
              Study data is missing a clinicaltrials.gov NCT number. Please add
              an NCT number to this protocol in OnCore to enable study website
              features.
            </MuiTypography>
          </MuiGrid>
        )}
      </MuiGrid>
    </InfoCard>
  );
};

WebsiteActivityCard.propTypes = {
  interestedCount: PropTypes.number.isRequired,
  interestCountFromCt: PropTypes.number.isRequired,
  isPublishable: PropTypes.bool.isRequired,
};

export default WebsiteActivityCard;
